import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30sn — sık değişmeyen veri için fresh kabul
      gcTime: 5 * 60_000, // 5dk cache tut
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})
